import yup from "yup";
import { ConsultantQualityItemEditorFragment } from "@graphql";
import { MetaData } from "./Statuses/StatusMeta";
import locale from "@bonliva-crm/locale";

export type FormData = {
  date: Date;
  selectedStatus: string;
  referenceId?: string;
  type?: string;
  from?: string;
};

export const schema = yup.object<FormData>({
  date: yup.date(),
  selectedStatus: yup.string().nullable(true)
});

export const referenceSchema = yup.object<FormData>({
  date: yup.date(),
  type: yup
    .string()
    .nullable(true)
    .required(locale.fieldIsMandatory(locale.WorkRelationship)),
  selectedStatus: yup.string().nullable(true)
});

export const nationalReferenceReferenceSchema = yup.object<FormData>({
  date: yup.date().required(locale.StartDateWhenDueShouldCount),
  type: yup
    .string()
    .nullable(true)
    .required(locale.fieldIsMandatory(locale.WorkRelationship)),
  selectedStatus: yup.string().nullable(true)
});

export function statusToMeta(status: ConsultantQualityItemEditorFragment["Status"]) {
  return { comment: status.Comment } as MetaData;
  // if (status.Name === "Approved") {
  //   return { comment: status.Comment } as ApprovedMetaData;
  // } else if (status.Name === "RequestSent") {
  //   return { comment: status.Comment } as RequestSentMetaData;
  // } else if (status.Name === "RequestReceivedNotProcessed") {
  //   return { comment: status.Comment } as RequestSentMetaData;
  // }
  //
  // throw new Error(`Unknown status ${status.Name}`);
}
